import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="1" y="12" width="2" height="4" rx="1"/><rect x="29" y="12" width="2" height="4" rx="1"/><path d="M24 2H8a4 4 0 00-4 4V24A1.9 1.9 0 005.8 26h20.4a1.9 1.9 0 001.8-1.9V6A4 4 0 0024 2zM10 22a2 2 0 112-2 2 2 0 01-2 2zm12 0a2 2 0 112-2 2 2 0 01-2 2zm4-8a2.1 2.1 0 01-2.2 2H8.2A2.1 2.1 0 016 14V8a2.1 2.1 0 012.2-2h15.6A2.1 2.1 0 0126 8zM19 26v2a2 2 0 002 2h2a2 2 0 002-2v-2zM7 26v2a2 2 0 002 2h2a2 2 0 002-2v-2z"/>';
export var BusSVG = function BusSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BusSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BusSVG);